import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "programs-grid-page ion-padding-horizontal" }
const _hoisted_2 = { class: "programs-grid" }
const _hoisted_3 = ["onClick", "onKeyup"]
const _hoisted_4 = { class: "program-tile-inner" }
const _hoisted_5 = ["src", "alt", "onError"]
const _hoisted_6 = { class: "programs-cards-page ion-padding-horizontal" }
const _hoisted_7 = {
  key: 0,
  class: "program-section"
}
const _hoisted_8 = { class: "program-hero program-hero--compact" }
const _hoisted_9 = { class: "program-hero-inner program-hero-inner--compact" }
const _hoisted_10 = { class: "program-hero-logo program-hero-logo--compact" }
const _hoisted_11 = ["src", "onError"]
const _hoisted_12 = { class: "releases-row" }
const _hoisted_13 = {
  key: 0,
  class: "release-card-wrap"
}
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "release-card-num-line"
}
const _hoisted_16 = { class: "release-card-num" }
const _hoisted_17 = {
  key: 1,
  class: "release-card-text-block"
}
const _hoisted_18 = { class: "release-card-text-title" }
const _hoisted_19 = {
  key: 0,
  class: "release-card-footer"
}
const _hoisted_20 = { class: "release-card-price-pill" }
const _hoisted_21 = {
  key: 1,
  class: "release-card-footer release-card-footer--muted"
}
const _hoisted_22 = { class: "release-card-float-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Релизы от Лиги",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: "main-background programs-page",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_segment, {
            value: _ctx.selectedListSegment,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listSegmentChange($event))),
            mode: "ios",
            class: "liga-glass-segment programs-segment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment_button, {
                mode: "ios",
                value: "all"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Все", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_segment_button, {
                mode: "ios",
                value: "favourites"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Избранное", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _withDirectives(_createVNode(_component_ion_content, {
            class: "bg-transparent programs-content",
            onIonScroll: _ctx.onContentScroll
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: program.id ?? programIdx,
                      class: "program-tile",
                      role: "button",
                      tabindex: "0",
                      onClick: ($event: any) => (_ctx.openProgramReleases(program)),
                      onKeyup: _withKeys(($event: any) => (_ctx.openProgramReleases(program)), ["enter"])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          class: "program-tile-logo",
                          src: _ctx.programLogos[program.shortName] || _ctx.getProgramImage(program.shortName),
                          alt: program.programName || 'Программа',
                          onError: ($event: any) => (_ctx.onProgramLogoError(program.shortName))
                        }, null, 40, _hoisted_5)
                      ])
                    ], 40, _hoisted_3))
                  }), 128))
                ])
              ]),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 8, ["onIonScroll"]), [
            [_vShow, _ctx.selectedListSegment == 'all']
          ]),
          _withDirectives(_createVNode(_component_ion_content, {
            class: "bg-transparent programs-content programs-content-favourites",
            onIonScroll: _ctx.onContentScroll
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'fav-p-' + (program.id ?? programIdx)
                  }, [
                    (_ctx.hasAnyFavourite(program))
                      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("img", {
                                  src: _ctx.programLogos[program.shortName] || _ctx.getProgramImage(program.shortName),
                                  alt: "",
                                  onError: ($event: any) => (_ctx.onProgramLogoError(program.shortName))
                                }, null, 40, _hoisted_11)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(program.fullReleases, (release) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'fav-r-' + release.id
                              }, [
                                (_ctx.isFavourite(program, release))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["release-card release-card--fav", { 'release-card--text-title': !_ctx.releaseTitleIsNumericOnly(release.releaseName) }]),
                                        disabled: _ctx.payingKey === _ctx.payKey(program, release),
                                        onClick: ($event: any) => (_ctx.onReleaseCardTap(program, release))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["release-card-main", {
                            'release-card-main--numeric': _ctx.releaseTitleIsNumericOnly(release.releaseName),
                            'release-card-main--text': !_ctx.releaseTitleIsNumericOnly(release.releaseName),
                          }])
                                        }, [
                                          (_ctx.releaseTitleIsNumericOnly(release.releaseName))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.releaseTitleTrimmed(release.releaseName)), 1),
                                                (release.canPurchase && !_ctx.releaseCatalogCanOpen(release))
                                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                      key: 0,
                                                      icon: _ctx.lockClosedOutline,
                                                      class: "release-lock release-lock--num",
                                                      "aria-hidden": "true"
                                                    }, null, 8, ["icon"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(release.releaseName), 1),
                                                (release.canPurchase && !_ctx.releaseCatalogCanOpen(release))
                                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                      key: 0,
                                                      icon: _ctx.lockClosedOutline,
                                                      class: "release-lock release-lock--text",
                                                      "aria-hidden": "true"
                                                    }, null, 8, ["icon"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                        ], 2),
                                        (release.canPurchase && release.priceKopecks && !_ctx.releaseCatalogCanOpen(release))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                              _createElementVNode("span", _hoisted_20, _toDisplayString((release.priceKopecks / 100).toFixed(0)) + " ₽", 1),
                                              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "release-card-buy-label" }, "Купить", -1))
                                            ]))
                                          : (!_ctx.releaseCatalogCanOpen(release))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("span", { class: "release-card-muted" }, "Нет доступа", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                        (_ctx.payingKey === _ctx.payKey(program, release))
                                          ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                              key: 2,
                                              name: "crescent",
                                              class: "release-card-spinner"
                                            }))
                                          : _createCommentVNode("", true)
                                      ], 10, _hoisted_14),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_ion_button, {
                                          fill: "clear",
                                          size: "small",
                                          class: "release-float-btn",
                                          onClick: _withModifiers(($event: any) => (_ctx.toggleFavourite(program, release)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.star
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 8, ["onIonScroll"]), [
            [_vShow, _ctx.selectedListSegment == 'favourites']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}